// Utility functions for Google Tag Manager (GTM) dataLayer interactions
export const initializeDataLayer = () => {
  window.dataLayer = window.dataLayer || [];
};

export const pushToDataLayer = (eventData) => {
  try {
    if (typeof window === 'undefined') {
      console.warn('DataLayer push called in non-browser environment');
      return false;
    }

    // Ensure dataLayer exists
    initializeDataLayer();

    // Push the event
    window.dataLayer.push(eventData);

    // Log in development mode
    if (process.env.NODE_ENV === 'development') {
      console.log('GTM Event Pushed:', eventData);
    }

    return true;
  } catch (error) {
    console.error('Error pushing to dataLayer:', error);
    return false;
  }
};

export const trackLoginAttempt = ({ user_id = null, response_code }) => {
  const eventData = {
    event: 'login_attempt',
    timestamp: new Date().toISOString(),
    user_id: user_id || 'not_authenticated',
    response_code: response_code,
  };

  return pushToDataLayer(eventData);
};

export const trackSmsVerificationAttempt = ({ user_id, response_code }) => {
  const eventData = {
    event: 'sms_verification_attempt',
    timestamp: new Date().toISOString(),
    user_id: user_id || 'unknown',
    response_code: response_code,
  };

  return pushToDataLayer(eventData);
};

export const trackBookDemoClick = () => {
  const eventData = {
    event: 'book_demo_click',
    timestamp: new Date().toISOString(),
  };

  return pushToDataLayer(eventData);
};

export const trackForgotPasswordClick = () => {
  const eventData = {
    event: 'forgot_password_click',
    timestamp: new Date().toISOString(),
  };

  return pushToDataLayer(eventData);
};

export const trackNavClick = ({
  user_id,
  company_id,
  nav_area,
  tab_name = null,
  subtab_name = null,
  subsubtab_name = null,
  profile_item = null,
}) => {
  const eventData = {
    event: 'nav_click',
    timestamp: new Date().toISOString(),
    user_id: user_id || 'unknown',
    company_id: company_id || 'unknown',
    nav_area,
    tab_name,
    subtab_name,
    subsubtab_name,
    profile_item,
  };

  return pushToDataLayer(eventData);
};
